import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { CssBaseline } from '@material-ui/core';
import MeetingProvider from './components/MeetingProvider';
import theme from './theme';


ReactDOM.render(
  <MuiThemeProvider theme={theme}>
    <CssBaseline />
    <MeetingProvider>
      <App />
    </MeetingProvider>
  </MuiThemeProvider>
  ,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
